import { AfterViewInit, Component, DoCheck, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChild, ViewChildren } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { SelectionModel } from "@angular/cdk/collections";
import { TextFilterComponent } from "./text-filter.component";
import { DateFilterComponent } from "./date-filter.component";

@Component({
  selector: "adc-table",
  templateUrl: "./adc-table.component.html",
  styleUrls: ["./adc-table.component.scss"],
  standalone: false
})
export class AdcTableComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild("dropdown1") dropdownRef1: ElementRef | undefined;
  @HostListener("document:click", ["$event"])
  onClick(event: Event) {
    if (
      this.dropdownRef1 &&
      !this.dropdownRef1.nativeElement.contains(event.target)
    ) {
      this.showManager = false;
    }
  }
  displayedColumns: any = [];
  columnData: any[] = [];
  @Input("dataSource") data: any;
  @Output() openLink = new EventEmitter();
  @Output() iconAction = new EventEmitter();
  @Output() openPopup = new EventEmitter<string>();
  @Output() selectedRowsChange = new EventEmitter<any>();
  dataSource = new MatTableDataSource();
  dataSourceCopy: any;
  @ViewChild(MatSort) sort: any = MatSort;
  globalFilters: any;
  @Input() noData: boolean = false;
  @Input() error: boolean = false;
  skeletonRows: number[] = new Array(25);
  showManager: boolean = false;
  searchData: any = {
    id: "1",
    theme: "blue",
    type: "basic",
    placeHolder: "Search",
    showIcon: true,
    icon: {
      iconId: "1",
      iconName: "searchIcon",
      iconPath: "search",
      iconAlternative: "Search icon",
    },
    customClass: "",
    customStyle: "",
    customAttribute: "",
    iconAlignment: "right",
    searchDisabled: false,
  };
  selection = new SelectionModel<any>(true, []);
  selectionRow = new SelectionModel<any>(true, []);

  pageNumber: number = 1;
  maxPage: number = 0;
  loading: boolean = false;

  @ViewChildren(TextFilterComponent)
  textFilters!: QueryList<TextFilterComponent>;
  @ViewChildren(DateFilterComponent)
  dateFilters!: QueryList<DateFilterComponent>;

  ngOnInit(): void {
    if (this.data?.searchDisabled) {
      this.searchData.searchDisabled = true;
    }
  }

  iconActionEvent(e: any, row: any, element: any) {
    if(e == 'edit') {
      element.isEditing = true;
    }
    this.iconAction.emit({ icon: e, rowData: row });
    // console.log(row, 'row___values');
  }

  updateTable() {
    this.columnData = Array.isArray(this.data?.columns) ? this.data.columns : [];
    // Use a Set to keep track of unique column names
    const uniqueColumnsSet = new Set<string>();
    // Clear the displayedColumns array before populating it
    this.displayedColumns = [];
    for (let column of this.columnData) {
      if (column.showColumn) {
        // Add column name to the Set (duplicates will be automatically handled)
        uniqueColumnsSet.add(column.ColName);
      }
    }
    // Convert the Set to an array and assign it to displayedColumns
    this.displayedColumns = Array.from(uniqueColumnsSet);
  
    // Sort setup
    // if (this.displayedColumns.length > 0) {
    //   this.sort.active = this.displayedColumns[1]; // Use the first column for sorting
    //   this.sort.direction = 'asc';
    //   this.sort.sortChange.emit();
    // }
    this.setDepth(this.data.data, 0);
    // Setup dataSource
    this.dataSource = new MatTableDataSource(this.data?.data ?? []);
    this.dataSource.sort = this.sort;
  }
  
  setDepth(data: any, depth: number = 0): void {
    data.forEach((item: any) => {
      item.depth = depth; // Set the depth for the current item
      if (item.children && item.children.length > 0) {
        // Recursively set depth for children, increasing depth by 1
        this.setDepth(item.children, depth + 1);
      }
    });
  }

  hideColumn(event: any, value: any) {
    value.showColumn = event.target.checked;
    this.displayedColumns = this.columnData
      .filter((column: any) => column.showColumn)
      .map((column: any) => column.ColName);
      // console.log(this.displayedColumns);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["data"] && changes["data"].currentValue) {
      // console.log(changes["data"].currentValue, "value changes");
      // console.log("hello");
      // console.log('Data received in ngOnChanges:', changes['data'].currentValue);
      this.updateTable();
      this.dataSource = new MatTableDataSource(
        changes["data"].currentValue?.data ?? []
      );
      this.dataSource.sort = this.sort;
    }
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  toggleRow(row: any) {
    row.isExpanded = !row.isExpanded;

    if (row.isExpanded && Array.isArray(row.children)) {
      row.children.forEach((child: any) => {
          child.parent = row;
          child.depth = (row.depth || 1) + 1; // Increment depth level
          console.log(child.depth);
          // Select the child row if it's part of the selection
          if (this.selectionRow.isSelected(row)) {
              this.selectionRow.select(child);
          }
      });

      const index = this.dataSource.data.indexOf(row);
      this.dataSource.data = [
          ...this.dataSource.data.slice(0, index + 1),
          ...row.children,
          ...this.dataSource.data.slice(index + 1)
      ];
    } else if (!row.isExpanded) {
        this.collapseAllChildren(row);
    }
  }

  collapseAllChildren(row: any) {
    // Get all direct and nested children
    const childRows = this.getAllChildren(row);
    // Remove all children from the dataSource
    this.dataSource.data = this.dataSource.data.filter((r: any) => !childRows.includes(r));
  }

  getAllChildren(row: any): any[] {
    row.isExpanded = false;
    let children: any[] = [];
    if (Array.isArray(row.children)) {
        row.children.forEach((child: any) => {
            children.push(child);
            if (child.isExpanded) {
                children = children.concat(this.getAllChildren(child));
            }
        });
    }
    return children;
  }

  openColLink(rowValue: any, colName: any) {
    this.openLink.emit({ row: rowValue, col: colName });
  }

  showColManager() {
    this.showManager = !this.showManager;
  }

  event(e: any) {
    e.preventDefault();
  }

  createGlobalFilterPredicate() {
    return (data: any, filters: string): boolean => {
      if (!filters) {
        this.dataSource = this.dataSourceCopy;
      }
      // Global filter logic
      const globalFilterValue = filters.trim().toLowerCase();
      let match = false;
      // Check if the global filter value matches any column data
      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const value = (data[key] || "").toString().toLowerCase();
          if (value.includes(globalFilterValue)) {
            match = true;
            break;
          }
        }
      }
      return match;
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  isAllColSelected() {
    // const numSelected = this.selectionRow.selected.length;
    // const numRows = this.dataSource.data.length;
    // // console.log(numSelected, numRows)
    // return numSelected === numRows;
    const numSelected = this.selectionRow.selected.length;

  // Flatten all rows and their children into a single array
    const flattenedData = this.dataSource.data;

    const numRows = flattenedData.length;
    console.log(numSelected, numRows)
    return numSelected === numRows;
  }

  handleChange(event: Event, row: any) {
    const input = event.target as HTMLInputElement;
    if (input.checked) {
      this.selection.select(row);
    } else {
      this.selection.deselect(row);
    }
    this.emitSelectedRows();
    // No need to emit here, will be done from parent
  }

  handleColChange(event: any, row: any): void {
    // if (event) {
    //   // this.selectionRow.toggle(row);
    //   const checkbox = event.target as HTMLInputElement;
    //   if (checkbox.checked) {
    //     this.selectionRow.select(row);
    //   } else {
    //     this.selectionRow.deselect(row);
    //   }
    //   // console.log(this.selectionRow)
    //   this.selectedRowsChange.emit({type: 'header', rows: this.selectionRow.selected});
    // }
    if (event.target.checked) {
      this.selectRowRecursively(row); // Select the row and all its descendants
    } else {
      this.deselectRowRecursively(row); // Deselect the row and all its descendants
    }

    this.selectedRowsChange.emit(this.selectionRow.selected.length);
  }

  selectRowRecursively(row: any): void {
    this.selectionRow.select(row); // Select the current row
    if (Array.isArray(row.children)) {
      row.children.forEach((child: any) => {
        this.selectRowRecursively(child); // Recursively select each child
      });
    }
  }

  deselectRowRecursively(row: any): void {
    this.selectionRow.deselect(row); // Deselect the current row
    if (Array.isArray(row.children)) {
      row.children.forEach((child: any) => {
        this.deselectRowRecursively(child); // Recursively deselect each child
      });
    }
  }

  emitSelectedRows() {
    this.selectedRowsChange.emit({type: 'header', rows: this.selection.selected});
  }

  masterToggle() {
    this.isAllSelected()
      ? this.selection.clear()
      : this.dataSource.data.forEach((row: any) => this.selection.select(row));
      this.emitSelectedRows();
  }

  masterColToggle() {
    // if (this.isAllColSelected()) {
    //   this.selectionRow.clear();
    // } else {
    //   this.dataSource.data.forEach((row: any) => {this.selectionRow.select(row);});
    // }
    if (this.isAllColSelected()) {
      this.selectionRow.clear(); // Clear all selections
      this.dataSource.data.forEach((row: any) => this.collapseAllChildren(row));
    } else {
      this.dataSource.data.forEach((row: any) => {
        this.selectRowAndExpandRecursively(row);
      });
    }
  }

  selectRowAndExpandRecursively(row: any): void {
    this.selectionRow.select(row); // Select the row
    row.isExpanded = true; // Expand the row
  
    if (Array.isArray(row.children)) {
      row.children.forEach((child: any) => {
        child.parent = row; // Assign parent reference
        child.depth = (row.depth || 1) + 1; // Set child depth
        this.selectRowAndExpandRecursively(child); // Recursively select and expand children
      });
  
      // Add children to the displayed data source
      const index = this.dataSource.data.indexOf(row);
      this.dataSource.data = [
        ...this.dataSource.data.slice(0, index + 1),
        ...row.children,
        ...this.dataSource.data.slice(index + 1)
      ];
    }
  }

  //Search
  getFilterValue(event: any) {
    this.globalFilters = event;
    const filterValues = this.globalFilters.trim().toLowerCase();
    this.dataSource.filter = filterValues;
    this.dataSource.filterPredicate = this.createGlobalFilterPredicate();
  }
}
